export const compesa = [
  {
    title: "Agreste Central",
    key: "agresteCentral",
    endereco:
      "Av. Bartolomeu de Anacleto, nº 10, Salgado, Caruaru (PE). CEP: 55018-320.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3572.9937369343083!2d-35.9526027088186!3d-8.274246578217493!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7a98a317faf2baf%3A0x50a02d74fd6f02fd!2sR.%20Bartolomeu%20Anacleto%2C%2010%20-%20Salgado%2C%20Caruaru%20-%20PE%2C%2055018-320!5e1!3m2!1spt-BR!2sbr!4v1758114360146!5m2!1spt-BR!2sbr",
  },
  {
    title: "Alto do Capibaribe",
    key: "altoDoCapibaribe",
    endereco:
      "Rua Galdêncio Gomes Feitosa, 7000, Bairro Oscarzão, Santa Cruz do Capibaribe (PE). CEP: 55190-000",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1787.8900035885029!2d-36.179285161562085!3d-7.961124241654747!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7a9741dd8a1b671%3A0x21ce56f96d62ef9b!2sR.%20Gaud%C3%AAncio%20Gomes%20Feitosa%20-%20Oscarz%C3%A3o%2C%20Santa%20Cruz%20do%20Capibaribe%20-%20PE%2C%2055190-000!5e1!3m2!1spt-BR!2sbr!4v1758117001696!5m2!1spt-BR!2sbr",
  },
  {
    title: "Agreste Meridional",
    key: "agresteMeridional",
    endereco: "Rua São Bento, nº 78, São José, Garanhuns (PE). CEP: 55295-340.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3567.236919203069!2d-36.4995747240663!3d-8.886554768339824!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7070ce975124307%3A0x74beb9e9ae111acc!2sR.%20S%C3%A3o%20Bento%2C%2078%20-%20S%C3%A3o%20Jos%C3%A9%2C%20Garanhuns%20-%20PE%2C%2055295-340!5e1!3m2!1spt-BR!2sbr!4v1758117088045!5m2!1spt-BR!2sbr",
  },
  {
    title: "Mata Sul",
    key: "mataSul",
    endereco:
      "Av. Henrique de Holanda, 2170, Alto José Leal, Vitória de Santo Antão (PE). CEP: 55608-001.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3574.401787152439!2d-35.305174625440756!3d-8.117508881232396!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7aa54a7f64b635f%3A0xde1c2d6e1daa4a75!2sAv.%20Henrique%20de%20Holanda%2C%202170%20-%20Caj%C3%A1%2C%20Vit%C3%B3ria%20de%20Santo%20Ant%C3%A3o%20-%20PE%2C%2055602-001!5e1!3m2!1spt-BR!2sbr!4v1758117154860!5m2!1spt-BR!2sbr",
  },
  {
    title: "Ipojuca",
    key: "ipojuca",
    endereco:
      "Rua São Benedito, s/n, Barragem Nova, Belo Jardim (PE). CEP: CEP: 55153-695.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3572.613964972164!2d-36.428843425437485!3d-8.316018683696463!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7a9c7ce753c8df9%3A0x36d1009ca1b50e2a!2sR.%20S%C3%A3o%20Benedito%20-%20Belo%20Jardim%2C%20PE%2C%2055153-695!5e1!3m2!1spt-BR!2sbr!4v1758117431138!5m2!1spt-BR!2sbr",
  },
  {
    title: "Pajeú",
    key: "pajeu",
    endereco:
      "Rua Manoel Pereira Lins, nº 1030, Nossa Senhora da Conceição, Serra Talhada (PE). CEP: 56903-917.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3575.5340518987555!2d-38.29599322414918!3d-7.989255359114963!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7a716466c47e055%3A0xabca41a8f6838db!2sR.%20Manoel%20Pereira%20Lins%2C%201030%20-%20S%C3%A3o%20Cristovao%2C%20Serra%20Talhada%20-%20PE%2C%2056903-340!5e1!3m2!1spt-BR!2sbr!4v1758117615292!5m2!1spt-BR!2sbr",
  },
  {
    title: "Mata Norte",
    key: "mataNorte",
    endereco:
      "R. da Independência, 203 - São José, Carpina - PE. CEP: 55815-020.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3576.7970389110783!2d-35.260738525445205!3d-7.84373717793949!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7aba04d2f6837dd%3A0x3c4c82f060bee254!2sR.%20da%20Independ%C3%AAncia%2C%20203%20-%20S%C3%A3o%20Jos%C3%A9%2C%20Carpina%20-%20PE%2C%2055815-020!5e1!3m2!1spt-BR!2sbr!4v1758117830410!5m2!1spt-BR!2sbr",
  },
  {
    title: "Russas",
    key: "russas",
    endereco:
      "Travessa Quintino bocaiúva, sn, centro, Gravatá - PE. CEP: 55642-011.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d3573.6741769417804!2d-35.57143852499071!3d-8.198874691832962!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zOMKwMTEnNTYuMCJTIDM1wrAzNCcwNy45Ilc!5e1!3m2!1spt-BR!2sbr!4v1758118033269!5m2!1spt-BR!2sbr",
  },
  {
    title: "Moxotó",
    key: "moxoto",
    endereco:
      "Rua Augusto Cavalcante, Número 207 - Loja 02 Centro - Arcoverde - PE. CEP: 56506-640.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3571.6678618335154!2d-37.0620206254359!3d-8.41918808500232!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7a81bea834c3543%3A0x7e1f92acec69a8e!2sR.%20Augusto%20Cavalcante%2C%20207%20-%20Centro%2C%20Arcoverde%20-%20PE%2C%2056506-640!5e1!3m2!1spt-BR!2sbr!4v1758118425549!5m2!1spt-BR!2sbr",
  },
  {
    title: "Alto do Pajeú",
    key: "altoDoPajeu",
    endereco:
      "Avenida Artur Padilha, nº 517, Centro, Afogados da Ingazeira (PE). CEP: 56800-000.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3577.6215546147064!2d-37.639853024169994!3d-7.747273456855065!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x7a637de5c7c0823%3A0xbe27a2635fe5f15a!2sAv.%20Artur%20Padilha%2C%20517%20-%20Afogados%20Da%20Ingazeira%2C%20Afogados%20da%20Ingazeira%20-%20PE%2C%2056800-000!5e1!3m2!1spt-BR!2sbr!4v1758118486647!5m2!1spt-BR!2sbr",
  },
  {
    title: "São Francisco",
    key: "saoFrancisco",
    endereco:
      "Av. Pres. Tancredo Neves, s/n - Vila Moco, Petrolina - PE. CEP: 56306-415",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3562.221274927626!2d-40.50778532401643!3d-9.387773874072085!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x77370655a1684cd%3A0x61604bf3095fbf6c!2sAv.%20Pres.%20Tancredo%20Neves%2C%20s%2Fn%20-%20Vila%20Moco%2C%20Petrolina%20-%20PE%2C%2056306-415!5e1!3m2!1spt-BR!2sbr!4v1758118764333!5m2!1spt-BR!2sbr",
  },
];

export const alagoas = [
  {
    title: "Maceió",
    key: "maceio",
    endereco:
      "R. Edgar de Góes de Monteiro, 317a - Clima Bom, Maceió - AL, CEP: 57071-000. Ao lado da Volvo.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3560.378371220553!2d-35.79023052399817!3d-9.565397776203156!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x70149b358b32075%3A0x19dbd3bbb0c78f32!2sR.%20Edgar%20de%20G%C3%B3es%20de%20Monteiro%2C%20317a%20-%20Clima%20Bom%2C%20Macei%C3%B3%20-%20AL%2C%2057071-000!5e1!3m2!1spt-BR!2sbr!4v1758627415231!5m2!1spt-BR!2sbr",
  },
  {
    title: "Arapiraca",
    key: "arapiraca",
    endereco:
      "R. Pedro Nunes de Albuquerque, 170 - Centro, Arapiraca - AL, CEP: 57300-550.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3558.4582551071953!2d-36.66650362541249!3d-9.747052503354597!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x705d59099ed653d%3A0x43cccbc1c14e9c1f!2sR.%20Pedro%20Nunes%20de%20Albuquerque%2C%20170%20-%20Centro%2C%20Arapiraca%20-%20AL%2C%2057300-550!5e1!3m2!1spt-BR!2sbr!4v1758628024343!5m2!1spt-BR!2sbr",
  },
  {
    title: "União dos Palmares",
    key: "uniaoDosPalmares",
    endereco:
      "Rodovia BR-104, Centro, União dos Palmares - AL, CEP: 57800-000.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3579.395317491179!2d-36.0090499254499!3d-7.535594474379092!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x70148330c7cc465%3A0x6bd2a2aba67d872a!2sBR-104!5e1!3m2!1spt-BR!2sbr!4v1758632380568!5m2!1spt-BR!2sbr",
  },
  {
    title: "Japaratinga",
    key: "japaratinga",
    endereco:
      "Rua Benedito Santiago Calaça, 320 - Centro, Japaratinga - AL, CEP: 57950-000.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1782.6275482492474!2d-35.26417675826082!3d-9.087876555369432!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x700f71978622283%3A0xd6d362275a7298b5!2sVerde%20Alagoas%20Polo%20Japaratinga!5e1!3m2!1spt-BR!2sbr!4v1758637133538!5m2!1spt-BR!2sbr",
  },
];

export const sergipe = [
  {
    title: "CallCenter",
    key: "callcenter",
    endereco: "Av. Ivo do Prado, 160 - Centro Aracaju - SE, CEP: 49100-065.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3545.255867225914!2d-37.05059632538977!3d-10.915299621866405!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x71ab37bd2d706a1%3A0x36662a643fe028fd!2sAv.%20Ivo%20do%20Prado%2C%20160%20-%20Centro%2C%20Aracaju%20-%20SE%2C%2049100-065!5e1!3m2!1spt-BR!2sbr!4v1758625964542!5m2!1spt-BR!2sbr",
  },
  {
    title: "Galpão",
    key: "galpao",
    endereco:
      "R. Marise Almeida Santos, 395 - LuziaAracaju - SE, CEP: 49045-670.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3545.0205199016505!2d-37.06926222538949!3d-10.935005022197538!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x71ab3bf3266ced3%3A0xae76c3c65cda01bd!2sR.%20Marise%20Almeida%20Santos%2C%20395%20-%20Luzia%2C%20Aracaju%20-%20SE%2C%2049045-670!5e1!3m2!1spt-BR!2sbr!4v1758626225612!5m2!1spt-BR!2sbr",
  },
  {
    title: "Região Norte",
    key: "regiaoNorte",
    endereco: "Av. Contôrno, 4126 - Centro, Lagarto - SE, CEP: 49400-000.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3545.1784054926748!2d-37.675517123848884!3d-10.92178929419567!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x71022e602914a7d%3A0x81311f4420d98682!2sAv.%20Cont%C3%B4rno%2C%204126%20-%20Centro%2C%20Lagarto%20-%20SE%2C%2049400-000!5e1!3m2!1spt-BR!2sbr!4v1758626445596!5m2!1spt-BR!2sbr",
  },
  {
    title: "Região Sul",
    key: "regiaoSul",
    endereco:
      "Av. do Oeste, 102 - Sebastião Lopes da Silva, Nossa Sra. da Glória - SE, CEP: 49.680-00.",
    mapUrl:
      "https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3553.3619452921225!2d-37.427602625403715!3d-10.213687610483571!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x70f788aaf6cbcc1%3A0x944f582f3935f115!2sAv.%20do%20Oeste%2C%20102%20-%20Sebasti%C3%A3o%20Lopes%20da%20Silva%2C%20Nossa%20Sra.%20da%20Gl%C3%B3ria%20-%20SE%2C%2049680-000!5e1!3m2!1spt-BR!2sbr!4v1758626568852!5m2!1spt-BR!2sbr",
  },
];
